import type { Testimonial } from '../types/content';
export const stats = [['5', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['100%', 'Listo para usar']];
export const testimonials: Testimonial[] = [{
  name: 'Mariana V.',
  place: 'Buenos Aires',
  quote: "Ordenaba todo y a los pocos días volvía el desorden. Ahora sé cómo organizar cada espacio y mantenerlo."
}, {
  name: 'Gabriela S.',
  place: 'Córdoba',
  quote: 'Me ayudó a revisar todas esas cosas que guardaba por las dudas. Ahora tengo más claro qué necesito conservar y qué puedo dejar ir.'
}, {
  name: 'Lucía P.',
  place: 'Rosario',
  quote: "Me gustó que no solo ayuda a ordenar la casa, sino también el celular, las rutinas y las compras."
}];
export const extendedTestimonials: Testimonial[] = [{
  name: 'Camila R.',
  place: 'Buenos Aires',
  quote: 'Me pasaba que ordenaba la casa y a los pocos días volvía a estar todo igual. Tener procedimientos concretos por ambiente me ayudó a organizarme de otra manera.'
}, {
  name: 'Andrea F.',
  place: 'Córdoba',
  quote: 'Lo que más valoro es tener criterios para decidir qué conservar y qué dejar ir. Antes guardaba de todo por las dudas y terminaba sin espacio.'
}, {
  name: 'Valeria S.',
  place: 'Mendoza',
  quote: 'Me gustó que el sistema también incluya el celular, los archivos y las compras. Son cosas que no relacionaba con el orden y ahora puedo trabajarlas de forma organizada.'
}, {
  name: 'Paula M.',
  place: 'Rosario',
  quote: 'El plan de siete días me dio un punto de partida. En lugar de querer cambiar todo de golpe, puedo avanzar con acciones pequeñas y concretas.'
}];
